<div class="select-list">
    <ng-container *ngFor="let option of options;index as i">
        <span (click)="changeSelect(option)" [ngClass]="{choose:value===option.value,label:true}">{{option.label}}</span>
        <span *ngIf="i !== options.length-1" class="line"></span>
    </ng-container>
</div>
